__turbopack_context__.v({
  "author-icon-img": "NextImage-module__AtbJUG__author-icon-img",
  "author-result-card": "NextImage-module__AtbJUG__author-result-card",
  "authorIconTop": "NextImage-module__AtbJUG__authorIconTop",
  "authorLinkImage": "NextImage-module__AtbJUG__authorLinkImage",
  "book-deals": "NextImage-module__AtbJUG__book-deals",
  "book-result-card": "NextImage-module__AtbJUG__book-result-card",
  "card-img-top": "NextImage-module__AtbJUG__card-img-top",
  "catelog-card-img-top": "NextImage-module__AtbJUG__catelog-card-img-top",
  "contentCard": "NextImage-module__AtbJUG__contentCard",
  "feedbackpage__bookimage": "NextImage-module__AtbJUG__feedbackpage__bookimage",
  "giveawaypage__bookimage": "NextImage-module__AtbJUG__giveawaypage__bookimage",
  "h-card-img-top": "NextImage-module__AtbJUG__h-card-img-top",
  "img-default": "NextImage-module__AtbJUG__img-default",
  "instructional": "NextImage-module__AtbJUG__instructional",
  "post-card-img": "NextImage-module__AtbJUG__post-card-img",
  "promoImage": "NextImage-module__AtbJUG__promoImage",
  "retailer": "NextImage-module__AtbJUG__retailer",
  "v-card-img-top": "NextImage-module__AtbJUG__v-card-img-top",
});
